<template>
  <div id="UploadMixedFiles_main">
    <!-- 不分檔案、圖片 -->
    <div>
      <input
        :id="`_${name}`"
        type="file"
        name="file[]"
        multiple="multiple"
        style="display: none"
        @change="addFileChangeEvent()"
      >
      <div class="file-wrap">
        <div
          v-for="(file,file_ind) in myfileArray"
          :key="file_ind"
          class="file"
          :class="file.FileUri ? 'oldFile' : ''"
        >
          <div
            class="fileName"
            @click="openFile(file.FileUri)"
          >
            {{ file.f || file.fileName }}
          </div>
          <i
            class="icon-close"
            aria-hidden="true"
            @click="deletFile(file_ind)"
          />
        </div>
        <div
          v-if="myfileArray.length < fileQuantity"
          class="file file-plus"
          @click="addFile()"
        >
          <i
            class="icon-plus"
            aria-hidden="true"
          />
          <span>新增檔案</span>
        </div>
      </div>
    </div>
    <el-dialog
      title="檔案上傳錯誤"
      :visible.sync="dialogVisible"
      width="40%"
      custom-class="alertDialog"
      append-to-body
    >
      <div class="left">
        <i
          class="icon-input-error"
          aria-hidden="true"
        />
      </div>
      <div class="right">
        <p>以下檔案不符合檔案類型或大小限制：</p>
        <div refs="alertMsg" />
        <div
          v-for="(item , index) in alertMsg"
          :key="index"
        >
          <p>{{ item }}</p>
        </div>
        <div class="fileCondition">
          <p>檔案類型僅允許 doc、docx、xlsx、xls、pdf、ppt、pptx</p>
          <p>每個檔案大小限 10MB 以下（不可為 0KB）</p>
        </div>
        <div class="fileCondition">
          <p>圖片類型僅允許 jpg、jpeg、png、gif</p>
          <p>每個圖片大小限 4MB 以下（不可為 0KB）</p>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          size="mini"
          @click="dialogVisible = false"
        >確定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    filearray: Array,
    quantity: Number // 檔案數量限制
  },
  data () {
    return {
      name: 'mixedFiles',
      myfileArray: this.filearray,
      fileQuantity: this.quantity,
      images: [],
      alertMsg: [],
      dialogVisible: false
    }
  },
  watch: {
    filearray: {
      handler (newVal, oldVal) {
        this.myfileArray = newVal
      },
      deep: true
    },
    myfileArray: {
      handler (newVal, oldVal) {
        this.$emit('on-fileArray-change', newVal)
      },
      deep: true
    }
  },
  methods: {
    addFile () {
      console.log(this.fileQuantity)
      if (this.myfileArray.length >= this.fileQuantity) {
        this.$alert('檔案最多為' + this.fileQuantity + '筆', '提示', {
          confirmButtonText: '確定',
          type: 'warning',
          callback: action => {}
        })
        return false
      }
      document.getElementById(`_${this.name}`).click()
    },
    addFileChangeEvent () {
      const acceptFileType = ['doc', 'docx', 'xlsx', 'xls', 'pdf', 'ppt', 'pptx']
      const acceptImgFileType = ['jpg', 'jpeg', 'png', 'gif']
      const acceptFileSize = 10485760
      const acceptImgFileSize = 4194304
      const files = document.getElementById(`_${this.name}`).files
      const newFiles = []
      this.alertMsg = []
      console.log(files)
      // 將檔案分類
      for (const file of files) {
        const fileType = file.name.split('.')[file.name.split('.').length - 1].toLowerCase()
        if (acceptFileType.indexOf(fileType) !== -1) { file.fileType = 'file' } else if (acceptImgFileType.indexOf(fileType) !== -1) { file.fileType = 'img' } else { file.fileType = '' }
      }
      for (const file of files) {
        const filesize = file.size
        if (file.fileType === '') { this.alertMsg.push(file.name) } else if (file.fileType === 'file' && filesize > acceptFileSize) { this.alertMsg.push(file.name) } else if (file.fileType === 'img' && filesize > acceptImgFileSize) { this.alertMsg.push(file.name) } else if (filesize === 0) { this.alertMsg.push(file.name) } else { newFiles.push(file) }
      }
      if (this.alertMsg.length !== 0) { this.dialogVisible = true }
      if (newFiles.length > 0) {
        for (const file of newFiles) {
          if (this.myfileArray.length < this.fileQuantity && file.fileType === 'file') {
            this.myfileArray.push({
              type: 'file',
              file,
              uploadUrl: '',
              fileName: file.name
            })
          } else if (this.myfileArray.length < this.fileQuantity && file.fileType === 'img') {
            this.getBS64(file, res => {
              if (this.myfileArray.length < this.fileQuantity) {
                this.myfileArray.push({
                  type: 'img',
                  file,
                  uploadUrl: '',
                  BS64: res,
                  fileName: file.name
                })
              }
            })
          }
        }
        document.getElementById(`_${this.name}`).value = ''
      } else {
        document.getElementById(`_${this.name}`).value = ''
      }
    },
    deletFile (index) {
      this.myfileArray.splice(index, 1)
    },
    getBS64 (file, callback) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function (e) {
        callback(this.result)
      }
    },
    addFileShow () {
      let flag = true
      if (this.fileQuantity === undefined || this.fileQuantity === 0) { flag = true } else { flag = this.myfileArray.length < this.fileQuantity }
      return flag
    },
    openFile (fileUri) {
      if (fileUri) { window.open(fileUri, '_blank') }
    }
  }
}
</script>
<style lang="sass" scoped>
#UploadMixedFiles_main
  .file-wrap
    .file
      width: 250px
      height: 35px
      line-height: 35px
      border: 2px solid $subFontColor
      color: $mainFontColor
      border-radius: 35px
      padding: 0px 10px
      margin-bottom: 10px
      position: relative
      display: flex
      .icon-close
        position: absolute
        right: 12px
        top: 10px
        font-size: 15px
        color: $dangerColor
        margin-left: 10px
        cursor: pointer
      .fileName
        text-overflow: ellipsis
        white-space: nowrap
        overflow: hidden
        width: 230px
        font-size: 15px
        font-weight: bold
      span
        width: 230px
        font-size: 15px
        font-weight: bold
    .oldFile
      cursor: pointer
    .file-plus
      border: 2px solid $mainColor
      color: $mainColor
      text-align: center
      cursor: pointer
      line-height: 35px
      &:hover
        box-shadow: inset 0 1px 2px -1px rgba(0,0,0,.075), 0 0 4px rgba(120,120,120,.5)
        transition: .4s
      .icon-plus
        position: absolute
        top: 7px
        left: 90px
        font-size: 20px
        margin-right: 5px
      span
        margin-left: 20px
</style>
<style lang="sass">
.alertDialog
  min-width: 240px
  .el-dialog__body
    display: flex
    padding: 20px 30px
    .left
      flex: 1
      .icon-input-error
        line-height: 214px
        font-size: 25px
        color: $dangerColor
    .right
      flex: 9
      p
        line-height: 22px
      .fileCondition
        padding-top: 20px
        margin-top: 20px
        border-top: $borderDark1 1px solid
</style>
